var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.6718C0 7.8352 7.16344 0.671753 16 0.671753C24.8366 0.671753 32 7.8352 32 16.6718C32 25.5083 24.8366 32.6718 16 32.6718C7.16344 32.6718 0 25.5083 0 16.6718Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5208 13.6767L15.5544 14.2304L14.9948 14.1626C12.9579 13.9027 11.1784 13.0214 9.66756 11.5413L8.92891 10.8069L8.73865 11.3492C8.33575 12.5582 8.59316 13.8349 9.43253 14.6936C9.8802 15.1682 9.77948 15.2359 9.00725 14.9535C8.73865 14.8631 8.50363 14.7953 8.48124 14.8292C8.4029 14.9083 8.6715 15.9365 8.88414 16.3432C9.17513 16.9082 9.76828 17.4618 10.4174 17.7895L10.9658 18.0493L10.3167 18.0606C9.68994 18.0606 9.66756 18.0719 9.73471 18.3092C9.95854 19.0436 10.8427 19.8232 11.8276 20.1622L12.5214 20.3995L11.9171 20.761C11.0218 21.2808 9.96973 21.5745 8.91772 21.5971C8.41409 21.6084 8 21.6536 8 21.6875C8 21.8005 9.36538 22.4332 10.16 22.6818C12.5438 23.4162 15.3753 23.0998 17.5017 21.8457C19.0126 20.9531 20.5235 19.1792 21.2286 17.4618C21.6091 16.5466 21.9896 14.8744 21.9896 14.0722C21.9896 13.5524 22.0232 13.4847 22.6499 12.8632C23.0192 12.5017 23.3662 12.1062 23.4333 11.9932C23.5452 11.7785 23.534 11.7785 22.9633 11.9706C22.012 12.3096 21.8777 12.2644 22.3477 11.756C22.6947 11.3944 23.1088 10.7391 23.1088 10.547C23.1088 10.5131 22.9409 10.5696 22.7506 10.6713C22.5492 10.7843 22.1015 10.9537 21.7658 11.0554L21.1614 11.2475L20.613 10.8747C20.3108 10.6713 19.8856 10.4453 19.6617 10.3775C19.0909 10.2193 18.218 10.2419 17.7032 10.4227C16.3042 10.9311 15.4201 12.2418 15.5208 13.6767Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0448b38b23fb2b80d7172538cce76b4a.svg";
export { ForwardRef as ReactComponent };